import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import isLoggedIn, {isGM, isSA, isIos, isMobileDevice, isRemoteUser} from '../../../utils/auth';
import {formatDiamondTitle, formatDiamondSku, formatCarat, formatRatio, formatShape, formatPrice, formatCost, formatCut, formatColor, formatClarity, formatSymmetry, formatPolish, formatLocation, getLocationId, formatMeasurements, formatTable, formatDepth, getUrlId} from '../../../utils/formatting';

import * as holdConst from '../../../constants/hold';
import * as api from '../../../constants/api';

import {DiamondSourceBannerContainer} from '../common/DiamondSourceBanner';

import {VideoPlayerContainer} from './VideoPlayer';
import RhinoLoading from '../common/RhinoLoading';
import RhinoModal from '../../common/modal/RhinoModal';

import * as authActionCreators from '../../../actions/auth';
import * as diamondsActionCreators from '../../../actions/diamonds';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, diamondsActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class SingleLabDiamond extends React.Component {

  constructor(props) {
    super(props);

    let displayTypes = [
      'LOADING',
      'DEFAULT',
      'IMAGE',
      'VIDEO',
    ];

    let initialDispaly = 'DEFAULT';

    this.diamondId = parseInt(getUrlId());

    this.state = {
      diamondId: this.diamondId,
      diamond: null,
      currentView: initialDispaly,
      isZoomed: false,

      transferModalOpen: false,
      transferMessage: '',
      transferName: '',
      transferApptDate: '',
      transferApptTime: '',
      transferBudget: '',

      transferApptDateError: '',

      transferLoc50ModalOpen: false,
      transferLoc50Message: '',
      transferLoc50Name: '',
      transferLoc50ApptDate: '',
      transferLoc50ApptTime: '',
      transferLoc50Budget: '',

      holdModalOpen: false,
      holdMessage: '',

      shareModalOpen: false,

      certificateModalOpen: false,
      plotModalOpen: false,
      requestSent: false,

      diamondNotFound: false,

      remoteImageModalOpen: false,
      remoteVideoModalOpen: false,
    }

    if(this.state.diamondId === null) {
      this.userNav('');
    }

    // Load diamond data;
    // In the future, can also search out via diamond results
    if(this.state.diamond === null) {

      this.props.fetchSingleDiamond(this.diamondId)
      .then((respData) => {
        
        let displayMedia = 'DEFAULT';
        if(respData.diamond.laying_ref_code) {
          displayMedia = 'VIDEO';
        } else if(respData.diamond.video) {
          displayMedia = 'VIDEO';
        } else if(respData.diamond.image) {
          displayMedia = 'IMAGE';
        }

        this.setState({ 
          diamond: respData.diamond,
          currentView: displayMedia,
        });
      })
      .catch((errorResp) => {
        this.setState({
          diamondNotFound: true,
        })
      });
    }
  }

  componentWillMount() {

  }

  userNav(page) {
    history.push('/' + page);
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getDefaultImage() {
    if(!this.state.diamond) {
      return '/img/diamonds/shapes/round.svg';
    } else {
      switch (this.state.diamond.shape) {
        case 'ROUNDS':
          return '/img/diamonds/shapes/round.svg';
        case 'OVALS':
          return '/img/diamonds/shapes/oval.svg';
        case 'EMERALD':
          return '/img/diamonds/shapes/emerald.svg';
        case 'PEAR SHAPE':
          return '/img/diamonds/shapes/pear.svg';
        case 'CUSHION':
          return '/img/diamonds/shapes/cushion.svg';
        case 'SQUARE OR PRINCESS':
          return '/img/diamonds/shapes/princess.svg';
        case 'RADIANT':
          return '/img/diamonds/shapes/radiant.svg';
        case 'MARQUISE':
          return '/img/diamonds/shapes/marquise.svg';
        case 'ASCHER':
          return '/img/diamonds/shapes/asscher.svg';
        case 'HEART SHAPE':
          return '/img/diamonds/shapes/heart.svg';
        case "L'AMOUR CUT":
          return '/img/diamonds/shapes/lamour.svg';
        case 'DAUSSI CUSHION':
          return '/img/diamonds/shapes/daussi.svg';
        default:
          return '/img/diamonds/shapes/round.svg';
      }
    }
  }

  renderDisplaySection() {
    if(this.state.currentView === 'VIDEO') {
      if(this.state.diamond.laying_ref_code) {
        return <div className='displayVideo'>
          <iframe src={'https://segoma.com/v.aspx?type=iframe&id=' + this.state.diamond.laying_ref_code}></iframe>
        </div>;
      } else {
        return <VideoPlayerContainer diamondObj={this.state.diamond} isZoomed={this.state.isZoomed} />;
      }
    }
    if(this.state.currentView === 'IMAGE') {
      if(this.state.diamond.laying_ref_code) {
        return (<div className={'displayImage'}>
          <div className='loadingImageNote'>Loading Image...</div>
          <img src={'https://segoma.com/ws/public/GetPhoto/first/0/' + this.state.diamond.laying_ref_code} />
        </div>);
      } else {
        return (<div className={this.state.isZoomed ? 'displayImage zoomed' : 'displayImage'}>
          <img src={'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + this.state.diamond.image} />
        </div>);
      }
    }
    if(this.state.currentView === 'DEFAULT') {
      return (<div className='displayDefault'>
        <img src={this.getDefaultImage()} />
        {this.state.diamond.image_uri || this.state.diamond.video_uri ?
          <div className='thirdPartyWrapper'>
            <div className='thirdPartyLabel'>Some third-party assets cannot be displayed. Click below to view:</div>
            <div className='thirdPartyActions'>
              {this.state.diamond.image_uri ?
                <div className='thirdPartyActionButton' onClick={this.openRemoteImageModal.bind(this)}>Image</div> :
                null
              }
              {this.state.diamond.video_uri ?
                <div className='thirdPartyActionButton' onClick={this.openRemoteVideoModal.bind(this)}>Video</div> :
                null
              }
            </div>
          </div> :
          null
        }
      </div>);
    }
    return null;
  }

  toggleZoom() {
    this.setState({ isZoomed: !this.state.isZoomed });
  }

  setDisplayView(displayType) {
    this.setState({ currentView: displayType });
  }

  getCost(diamond) {
    if(!isLoggedIn() || diamond.cost === null || diamond.cost === 0) {
      return '';
    } else {
      if(this.props.auth.hideData) {
        return '';
      } else {
        return '(' + formatCost(diamond) + ')';
      }
    }
  }

  openCertModal() {
    if(isIos() || true) {
      let win = window.open('https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + this.state.diamond.certificate, '_blank');
      win.focus();
    } else {
      this.setState({ certificateModalOpen: true });
    }
  }

  closeCertModal() {
    this.setState({ certificateModalOpen: false });
  }

  openPlotModal() {
    this.setState({ plotModalOpen: true });
  }

  closePlotModal() {
    this.setState({ plotModalOpen: false });
  }

  openRemoteImageModal() {
    this.openNew(this.state.diamond.image_uri);
    // this.setState({ remoteImageModalOpen: true });
  }

  closeRemoteImageModal() {
    this.setState({ remoteImageModalOpen: false });
  }

  openRemoteVideoModal() {
    this.openNew(this.state.diamond.video_uri);
    // this.setState({ remoteVideoModalOpen: true });
  }

  closeRemoteVideoModal() {
    this.setState({ remoteVideoModalOpen: false });
  }

  validateTransfer() {
    if(!this.state.transferApptDate) {
      this.setState({
        transferApptDateError: 'Please enter an appointment date',
      });
      return false;
    }
    return true;
  }

  transferDiamond() {

    if(this.validateTransfer() === false) {
      return null;
    }
    
    this.setState({
      requestSent: true,
      transferModalOpen: false,
    }, () => {

      let transferData = {
        diamonds: [this.state.diamond.id],
        message_body: this.composeTransferMessage(),
        appointment_date: this.state.transferApptDate,
      }

      this.props.messagesSendTransferReq(transferData)
      .then((respData) => {
        this.props.messagesShowConfirmation('Transfer request sent');
      })
      .catch((errorResp) => {
        // console.error(errorResp);
        if(errorResp.message) {
          this.props.messagesShowConfirmation('Transfer not sent. ' + errorResp.message);  
        }
      });
    });
  }

  transferLoc50Diamond() {
    this.props.messagesShowConfirmation('Sold online request sent');
    this.setState({
      requestSent: true,
      transferLoc50ModalOpen: false,
    }, () => {

      let transferData = {
        diamonds: [this.state.diamond.id],
        message_body: this.composeTransferLoc50Message(),
      }

      this.props.messagesSendTransferLoc50Req(transferData)
      .then((respData) => {
        // Do nothing
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  holdDiamond() {
    this.props.messagesShowConfirmation('Hold request sent');
    this.setState({
      requestSent: true,
      holdModalOpen: false,
    }, () => {

      let holdData = {
        diamonds: [this.state.diamond.id],
        message_body: this.state.holdMessage,
      }

      this.props.messagesSendHoldReq(holdData)
      .then((respData) => {
        // Do nothing
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  queueShare(diamond) {
    this.props.usersAddToShareQueue([diamond], window.location.pathname);
    this.userNav('customer-profile');
  }

  shouldDisplayZoom() {
    return (this.state.currentView == 'VIDEO' || this.state.currentView == 'IMAGE') && !isMobileDevice() && isLoggedIn();
  }

  isOnHold(diamond) {
    if(diamond.last_hold === null) {
      return false;
    }
    let holdTime = new Date(diamond.last_hold);
    let now = new Date();

    if((now - holdTime) <= holdConst.HOLD_DURATION) {
      return true;
    }
    return false;
  }

  changeTransferName(evt) {
    this.setState({ transferName: evt.target.value });
  }

  changeTransferApptDate(evt) {
    this.setState({ transferApptDate: evt.target.value });
  }

  changeTransferApptTime(evt) {
    this.setState({ transferApptTime: evt.target.value });
  }

  changeTransferBudget(evt) {
    this.setState({ transferBudget: evt.target.value });
  }

  changeTransferMessage(evt) {
    this.setState({ transferMessage: evt.target.value });
  }

  openTransferModal() {
    this.setState({ 
      transferModalOpen: true, 
      transferApptDateError: '', 
    });
  }

  closeTransferModal() {
    this.setState({ transferModalOpen: false });
  }

  composeTransferMessage() {
    let baseMessage = '';
    if(this.state.transferName !== '') {
      baseMessage = baseMessage + 'Customer name: ' + this.state.transferName + '\n';
    }
    if(this.state.transferApptDate !== '') {
      baseMessage = baseMessage + 'Appointment Date: ' + this.state.transferApptDate + '\n';
    }
    if(this.state.transferApptTime !== '') {
      baseMessage = baseMessage + 'Appointment Time: ' + this.state.transferApptTime + '\n';
    }
    if(this.state.transferBudget !== '') {
      baseMessage = baseMessage + 'Budget: ' + this.state.transferBudget + '\n';
    }
    if(this.state.transferMessage !== '') {
      baseMessage = baseMessage + 'Message: ' + this.state.transferMessage;
    }
    return baseMessage;
  }

  changeTransferLoc50Name(evt) {
    this.setState({ transferLoc50Name: evt.target.value });
  }

  changeTransferLoc50ApptDate(evt) {
    this.setState({ transferLoc50ApptDate: evt.target.value });
  }

  changeTransferLoc50ApptTime(evt) {
    this.setState({ transferLoc50ApptTime: evt.target.value });
  }

  changeTransferLoc50Budget(evt) {
    this.setState({ transferLoc50Budget: evt.target.value });
  }

  changeTransferLoc50Message(evt) {
    this.setState({ transferLoc50Message: evt.target.value });
  }

  openTransferLoc50Modal() {
    this.setState({ transferLoc50ModalOpen: true });
  }

  closeTransferLoc50Modal() {
    this.setState({ transferLoc50ModalOpen: false });
  }

  composeTransferLoc50Message() {
    let baseMessage = '';
    if(this.state.transferLoc50Name !== '') {
      baseMessage = baseMessage + 'Customer name: ' + this.state.transferLoc50Name + '\n';
    }
    if(this.state.transferLoc50ApptDate !== '') {
      baseMessage = baseMessage + 'Sales Associate Name/Number: ' + this.state.transferLoc50ApptDate + '\n';
    }
    if(this.state.transferLoc50ApptTime !== '') {
      baseMessage = baseMessage + 'Sold Date: ' + this.state.transferLoc50ApptTime + '\n';
    }
    if(this.state.transferLoc50Budget !== '') {
      baseMessage = baseMessage + 'Sales Order Number: ' + this.state.transferLoc50Budget + '\n';
    }
    if(this.state.transferLoc50Message !== '') {
      baseMessage = baseMessage + 'Message: ' + this.state.transferLoc50Message;
    }
    return baseMessage;
  }

  changeHoldMessage(evt) {
    this.setState({
      holdMessage: evt.target.value,
    });
  }

  openHoldModal() {
    this.setState({ holdModalOpen: true });
  }

  closeHoldModal() {
    this.setState({ holdModalOpen: false });
  }

  openShareDiamond() {
    this.props.leadsOpenShareDirectDropdown([this.state.diamond]);
  }

  openShareInternal() {

    // // Make list of diamond objects
    // let diamonds = [];
    // for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
    //   for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
    //     if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
    //       diamonds.push(this.props.diamonds.diamondResults[j]);
    //       break;
    //     }
    //   }
    // }
    this.props.messagesOpenNewDiamondDropdown([this.state.diamond]);
    this.setState({ shareModalOpen: false });
  }

  openShareExternal() {

    // // Make list of diamond objects
    // let diamonds = [];
    // for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
    //   for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
    //     if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
    //       diamonds.push(this.props.diamonds.diamondResults[j]);
    //       break;
    //     }
    //   }
    // }
    this.props.leadsOpenAddDropdown([this.state.diamond]);
    this.setState({ shareModalOpen: false });
  }

  closeShareModal() {
    this.setState({ shareModalOpen: false });
  }

  addIndividualDiamondToCard() {

    if(this.props.users.customerCard === null) {
      return;
    }

    let addData = {
      card_id: this.props.users.customerCard.id,
      diamonds: [ this.state.diamond.id ],
    }

    this.props.leadsAddDiamonds(addData)
    .then((respData) => {
      // Do nothing
    })
    // .catch((errorResp) => {
    //   // console.error(errorResp);
    // });
  }

  backButtonNav() {
    window.history.back();
  }

  findSimilar() {

    const colorOptions = [ 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M' ];
    const clarityOptions = [ 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1' ];

    let colorRange = this.state.diamond.color;
    let clarityRange = this.state.diamond.clarity;

    const colorIdx = colorOptions.indexOf(this.state.diamond.color);
    if(colorIdx > 0) {
      colorRange = colorOptions[colorIdx - 1] + ',' + colorRange;
    }
    if(colorIdx < colorOptions.length - 1) {
      colorRange = colorRange + ',' + colorOptions[colorIdx + 1];
    }

    const clarityIdx = clarityOptions.indexOf(this.state.diamond.clarity);
    if(clarityIdx > 0) {
      clarityRange = clarityOptions[clarityIdx - 1] + ',' + clarityRange;
    }
    if(clarityIdx < clarityOptions.length - 1) {
      clarityRange = clarityRange + ',' + clarityOptions[clarityIdx + 1];
    }

    const diamondFilter = {
      carat_min: parseFloat((parseFloat(this.state.diamond.carat_weight) * 0.95).toFixed(2)),
      carat_max: parseFloat((parseFloat(this.state.diamond.carat_weight) * 1.05).toFixed(2)),
      length_min: parseFloat((parseFloat(this.state.diamond.length) * 0.97).toFixed(2)),
      length_max: parseFloat((parseFloat(this.state.diamond.length) * 1.03).toFixed(2)),
      width_min: parseFloat((parseFloat(this.state.diamond.width) * 0.97).toFixed(2)),
      width_max: parseFloat((parseFloat(this.state.diamond.width) * 1.03).toFixed(2)),
      height_min: parseFloat((parseFloat(this.state.diamond.height) * 0.97).toFixed(2)),
      height_max: parseFloat((parseFloat(this.state.diamond.height) * 1.03).toFixed(2)),

      table_min: parseInt(this.state.diamond.table - 3),
      table_max: parseInt(this.state.diamond.table + 3),

      shape: this.state.diamond.shape,
      color: colorRange,
      clarity: clarityRange,
      polish: this.state.diamond.polish,
      symmetry: this.state.diamond.symmetry,

      search_term: '',
      sort: 'price',

      page: 1,
    }

    // Remove any previous results
    this.props.diamondsSave(null);

    this.props.setDiamondFilters(diamondFilter);
    history.push('/results');
  }

  render() {

    // let base_url = window.location.protocol + '//' + location.hostname;
    let base_url = api.FRONTEND_URL;

    return <div className={'SingleDiamond SingleLabDiamond'}>
      <DiamondSourceBannerContainer showTabs={false} />
      {!this.state.diamond ?
        <div>
          {this.state.diamondNotFound ?
            <div className='diamondNotFound'>
              <div className='notFoundTitle'>Diamond Not Found</div>
              <div className='notFoundSubtitle'>This diamond is not currently available or not found</div>
              <div className='backButtonWrapper'>
                <div className={'backButton actionButton'} onClick={() => this.userNav('diamonds')}>Back to Search</div>
              </div>
            </div> :
            <div className='diamondLoadingWrapper'>
              <RhinoLoading message='Loading diamond' />
            </div>
          }
        </div> :
        <div>
          <div className={isLoggedIn() ? 'singleDiamondHeader loggedInHeader' : 'singleDiamondHeader'}>Diamond Profile</div>
          <div className='displaySection'>
            <div className='displayWrapper'>{this.renderDisplaySection()}</div>
            <div className='displayControlsWrapper'>
              {this.state.diamond.video || this.state.diamond.laying_ref_code ?
                <div className={'controlVideo controlElement'} onClick={() => this.setDisplayView('VIDEO')}>
                  <img src='/img/singlediamond/360.svg' />
                </div> :
                null
              }
              {this.state.diamond.image || this.state.diamond.laying_ref_code ?
                <div className={'controlImage controlElement'} onClick={() => this.setDisplayView('IMAGE')}>
                  <img src='/img/singlediamond/diamond_top.svg' />
                </div> :
                null
              }
              {this.shouldDisplayZoom() && !this.state.diamond.laying_ref_code ?
                <div className={'controlZoom controlElement'} style={{bottom: this.state.currentView == 'VIDEO' ? '15px' : '0'}} onClick={this.toggleZoom.bind(this)}>
                  <img src='/img/singlediamond/magnify.svg' />
                </div> :
                null
              }
            </div>
          </div>
          <div className='infoSection'>
            {isLoggedIn() && this.isOnHold(this.state.diamond) ?
              <div className='onHoldWrapper' onClick={() => this.props.messagesOpenNewDiamondDropdown([this.state.diamond])}>
                <div className='onHoldImgWrapper'>
                  <img src='/img/singlediamond/hold.svg' />
                </div>
                <div className='onHoldLabelWrapper'>On Hold</div>
              </div> :
              null
            }
            {isLoggedIn() ?
              <div className='shareIconWrapper' onClick={this.openShareDiamond.bind(this)}>
                <div className='shareImgWrapper'>
                  <img src='/img/singlediamond/share.svg' />
                </div>
                <div className='shareLabelWrapper'>share</div>
              </div> :
              null
            }
            <div className='diamondTitle'>{formatDiamondTitle(this.state.diamond)}</div>
            <div className='diamondSku'>{formatDiamondSku(this.state.diamond)}</div>
            <div className='diamondMeasurements'>{this.state.diamond.measurements}</div>
            {this.state.diamond.is_available === false ? 
              <div className='diamondOutOfStock'>This diamond is no longer available</div> :
              null
            }
            <div className='assetButtonsWrapper'>
              {this.state.diamond.certificate ? 
                <div className={'viewCertificateButton secondaryButton'} onClick={this.openCertModal.bind(this)}>View Certificate</div> :
                null
              }
              {this.state.diamond.plot_diagram ? 
                <div className={'viewPlotButton secondaryButton'} onClick={this.openPlotModal.bind(this)}>View Plot Diagram</div> :
                null
              }
            </div>
            <RhinoModal open={this.state.certificateModalOpen}>
              <div className='assetModal'>
                <div className={'assetWrapper'}>
                  {this.state.diamond.certificate && this.state.diamond.certificate.indexOf('pdf') > -1 ?
                    <iframe src={'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + this.state.diamond.certificate}></iframe> :
                    <img src={'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + this.state.diamond.certificate} />
                  }
                </div>
                <div className={'modalActions confirmActions'}>
                  <button 
                    className={'confirmClose actionButton'}
                    onClick={this.closeCertModal.bind(this)}>
                    Close
                  </button>
                </div>
              </div>
            </RhinoModal>
            <RhinoModal open={this.state.plotModalOpen}>
              <div className='assetModal'>
                <div className={'assetWrapper'}>
                  <img src={'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + this.state.diamond.plot_diagram} />
                </div>
                <div className={'modalActions confirmActions'}>
                  <button 
                    className={'confirmClose actionButton'}
                    onClick={this.closePlotModal.bind(this)}>
                    Close
                  </button>
                </div>
              </div>
            </RhinoModal>

            <RhinoModal open={this.state.remoteImageModalOpen}>
              <div className='assetModal'>
                <div className={'assetWrapper'}>
                  {this.state.diamond.image_uri ?
                    <iframe src={this.state.diamond.image_uri}></iframe> :
                    null
                  }
                </div>
                <div className={'modalActions confirmActions'}>
                  <button 
                    className={'confirmClose actionButton'}
                    onClick={this.closeRemoteImageModal.bind(this)}>
                    Close
                  </button>
                </div>
              </div>
            </RhinoModal>

            <RhinoModal open={this.state.remoteVideoModalOpen}>
              <div className='assetModal'>
                <div className={'assetWrapper'}>
                  {this.state.diamond.video_uri ?
                    <iframe src={this.state.diamond.video_uri}></iframe> :
                    null
                  }
                </div>
                <div className={'modalActions confirmActions'}>
                  <button 
                    className={'confirmClose actionButton'}
                    onClick={this.closeRemoteVideoModal.bind(this)}>
                    Close
                  </button>
                </div>
              </div>
            </RhinoModal>

            {!isLoggedIn() ?
              <div className='shareWrapper'>
                <div className='shareLabel'>Share with:</div>
                <div className='shareIconRow'>
                  {this.props.users.customerCard ?
                    <a href={'mailto:' + this.props.users.customerCard.email + '?subject=' + encodeURIComponent('My diamond collection') + '&body=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key)}>
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/email.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.diamond)}>
                      <img src='/img/icons/share/email.svg' />
                    </div>
                  }
                  {this.props.users.customerCard ?
                    <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key} target="_blank" style={{display: 'none'}}>
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/facebook.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.diamond)} style={{display: 'none'}}>
                      <img src='/img/icons/share/facebook.svg' />
                    </div>
                  }
                  {this.props.users.customerCard ?
                    <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key)} target="_blank">
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/whatsapp.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.diamond)}>
                      <img src='/img/icons/share/whatsapp.svg' />
                    </div>
                  }
                  {this.props.users.customerCard ?
                    <a href={'sms:?&body=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key)}>
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/text.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.diamond)}>
                      <img src='/img/icons/share/text.svg' />
                    </div>
                  }
                </div>
              </div> :
              null
            }
            <div className='locationRowWrapper'>
              <div className='mountedWrapper'>{this.state.diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
              <div className='locationWrapper'>
                <div className='locationIcon'>
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className='locationValue'>{formatLocation(this.state.diamond)}</div>
              </div>
            </div>
            <div className='detailWrapper'>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Price:</div>
                    <div className='detailValue'>{formatPrice(this.state.diamond)}<span className={this.props.auth.hideData ? 'costWrapper costHidden' : 'costWrapper'}>{this.getCost(this.state.diamond)}</span></div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Carat:</div>
                    <div className='detailValue'>{formatCarat(this.state.diamond)}</div>
                  </div>

                  
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Color:</div>
                    <div className='detailValue'>{formatColor(this.state.diamond)}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Clarity:</div>
                    <div className='detailValue'>{formatClarity(this.state.diamond)}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Cut:</div>
                    <div className='detailValue'>{formatCut(this.state.diamond)}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Polish:</div>
                    <div className='detailValue'>{formatPolish(this.state.diamond)}</div>
                  </div>
                </div>
              </div>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Symmetry:</div>
                    <div className='detailValue'>{formatSymmetry(this.state.diamond)}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Table:</div>
                    <div className='detailValue'>{formatTable(this.state.diamond)}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Depth:</div>
                    <div className='detailValue'>{formatDepth(this.state.diamond)}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Fluorescence:</div>
                    <div className='detailValue'>{this.state.diamond.flourescence}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Lab:</div>
                    <div className='detailValue'>
                      {this.state.diamond.lab.includes('EGL') ? '' : this.state.diamond.lab}
                      {this.state.diamond.lab == 'GIA' && this.state.diamond.gia_number ?
                        <span>{' - ' + this.state.diamond.gia_number}</span> :
                        null
                      }
                    </div>
                  </div>
                  {this.state.diamond.shape != 'ROUNDS' ?
                    <div className='detailEntry'>
                      <div className='detailLabel'>Ratio:</div>
                      <div className='detailValue'>{formatRatio(this.state.diamond)}</div>
                    </div> :
                    null
                  }
                </div>
              </div>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Case location:</div>
                    <div className='detailValue'>{this.state.diamond.case_location ? this.state.diamond.case_location : 'Unassigned'}</div>
                  </div>
                </div>
                {this.props.auth.hideData === false ?
                  <div className='detailColumn'>
                    <div className='detailEntry'>
                      <div className='detailLabel'>Days to Sell:</div>
                      <div className='detailValue'>{this.state.diamond.days_to_sell ? this.state.diamond.days_to_sell : 'n/a'}</div>
                    </div>
                  </div> :
                  <div className='detailColumn'>
                  </div>
                }
                {this.props.auth.hideData === false ?
                  <div className='detailColumn'>
                    <div className='detailEntry'>
                      <div className='detailLabel'>Ownership:</div>
                      <div className='detailValue'>{this.state.diamond.is_owned ? 'Owned' : 'Memo'}</div>
                    </div>
                  </div> :
                  <div className='detailColumn'>
                  </div>
                }
              </div>
            </div>
            <div className='manageDiamondActions'>
              {isLoggedIn() ?
                <div>
                  <button 
                    className={'transferButton manageButton secondaryButton'} 
                    disabled={this.state.requestSent || this.isOnHold(this.state.diamond) || this.state.diamond.is_available === false} 
                    onClick={this.openTransferModal.bind(this)}>Transfer</button>
                  <button 
                    className={this.isOnHold(this.state.diamond) ? 'holdButton onHoldStatus manageButton secondaryButton' : 'holdButton manageButton secondaryButton'} 
                    disabled={this.state.requestSent || this.isOnHold(this.state.diamond) || this.state.diamond.is_available === false} 
                    onClick={this.openHoldModal.bind(this)}>
                    {this.isOnHold(this.state.diamond) ? 'On Hold' : 'Hold'}
                  </button>
                  {isRemoteUser() && false ?
                    <button 
                      className={'transferButton manageButton secondaryButton'} 
                      disabled={this.state.requestSent || this.isOnHold(this.state.diamond) || this.state.diamond.is_available === false} 
                      onClick={this.openTransferLoc50Modal.bind(this)}>Sold Online</button> :
                    null
                  }
                  <button 
                    className={'transferButton manageButton secondaryButton'} 
                    disabled={false} 
                    onClick={() => this.findSimilar()}>Find Similar</button>
                </div> :
                null
              }
            </div>
            <div className='backToResultsWrapper'>
              <div className={'backToResultsButton bottomAction alwaysBottom'} onClick={this.backButtonNav.bind(this)}>Back to Results</div>
            </div>
          </div>
        </div>
      }
      <RhinoModal
        open={this.state.holdModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closeHoldModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Hold Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeHoldMessage.bind(this)} 
              value={this.state.holdMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.holdDiamond.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.transferModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closeTransferModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Transfer Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferName.bind(this)}
              value={this.state.transferName}
              placeholder='Customer Name' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              className={this.state.transferApptDateError ? 'error' : ''}
              onChange={this.changeTransferApptDate.bind(this)}
              value={this.state.transferApptDate}
              placeholder='Appointment Date*' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferApptTime.bind(this)}
              value={this.state.transferApptTime}
              placeholder='Appointment Time' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferBudget.bind(this)}
              value={this.state.transferBudget}
              placeholder='Estimated Budget' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeTransferMessage.bind(this)} 
              value={this.state.transferMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.transferDiamond.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.transferLoc50ModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closeTransferLoc50Modal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Sold Online Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferLoc50Name.bind(this)}
              value={this.state.transferLoc50Name}
              placeholder='Customer Name' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferLoc50ApptDate.bind(this)}
              value={this.state.transferLoc50ApptDate}
              placeholder='Sales Associate Name/Number' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferLoc50ApptTime.bind(this)}
              value={this.state.transferLoc50ApptTime}
              placeholder='Sold Date' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferLoc50Budget.bind(this)}
              value={this.state.transferLoc50Budget}
              placeholder='Sales Order Number' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeTransferLoc50Message.bind(this)} 
              value={this.state.transferLoc50Message}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.transferLoc50Diamond.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.shareModalOpen}>
        <div className='shareModal'>
          <div className='closeModal' onClick={this.closeShareModal.bind(this)}>&times;</div>
          <div className='shareModalTitle'>Who would you like to share with?</div>
          <div className='shareModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='shareModalButtons'>
            <button className={'actionButton shareButton'} onClick={this.openShareInternal.bind(this)}>Employees</button>
            <button className={'actionButton shareButton'} onClick={this.openShareExternal.bind(this)}>Customers</button>
          </div>
        </div>
      </RhinoModal>
    </div>;
  }
}
export default SingleLabDiamond;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    diamonds: state.diamonds,
    users: state.users,
  };
}

export const SingleLabDiamondContainer = connect(
  mapStateToProps,
  allActionCreators
)(SingleLabDiamond);